window.jQuery = window.$ = require('jquery');
var MatchHeight = require('jquery-match-height');
var enquire = require('enquire.js');

(function(window, document, $) {

  $(document).ready(function() {

    enquire.register("screen and (min-width: 768px)", {
      match : function() {
        $('.match-height > div[class^=col]').not('.visible-xs').matchHeight();
        setTimeout(function(){
          $('.match-height > div[class^=col]').not('.visible-xs').matchHeight();
        }, 500);
      },
      unmatch : function() {
        $('.match-height > div[class^=col]').not('.visible-xs').matchHeight({remove:true});
      }
    });

    // Animated scrolling
    $("a.scroll-link").click(function(event){
      event.preventDefault();
      var scrollTarget = $(this).data('scroll-target');
      var scrollTargetElement = $(scrollTarget);
      $('html,body').animate({scrollTop: scrollTargetElement.offset().top - 20},'slow');
    });

  });

}(window, window.document, window.jQuery)); // Fully reference jQuery after this point.



/** WEBPACK FOOTER **
 ** ./js/utilities.js
 **/